import { render, staticRenderFns } from "./baixados.vue?vue&type=template&id=85baa8ae&"
import script from "./baixados.vue?vue&type=script&lang=js&"
export * from "./baixados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports